module.exports = "/_next/static/images/Hero-xs@2x-fc26f6f23d1c61bf0392ac47e5c0c646.png";